/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { Column } from '../../../layout/flexbox';
import { Input } from '../../../forms/elements/Input';
import { COLUMN_SPACING } from '../../../forms/styles';
import LabelGroup from '../../../forms/elements/LabelGroup';
import CopyToClipboardButton from '../../../copyToClipboard/CopyToClipboardButton';
import { isNilOrEmpty } from '../../../language/module';
import { getResource } from '../../../language/resources/getResource';
import { IAppState } from '../../../core/redux/IAppState';
import { useSelector } from 'react-redux';
import { MAX_CORRECTION_NOTE_LENGTH } from './module';
import { BigNeutral } from '../../../forms/elements/buttons';


const onNoteChange = onChange => event => onChange(event.target.value);

type Props = {
  redemptionId: string | undefined,
  onSave: () => void,
  note?: string,
  onNoteChange: (note: string) => void;
  rootCss?: SerializedStyles,
};

/**
 * DayCorrectionForm
 * This component shows the redemption ID and allows for it to be copied to clipboard
 * It also has an input for note and a save button to submit it after a note has been provided.
 */
export const DayCorrectionForm: React.FC<Props> = (props: Props) => {
  const resources = useSelector((state: IAppState) => state.locale);

  return (
  <Column rootCss={css`
              ${COLUMN_SPACING};
              ${props.rootCss};
            `}>
    <LabelGroup label={getResource(resources, 'DAY_CORRECTION_REDEMPTION_LABEL')} rootCss={css`pointer-events: none;`}>
      <CopyToClipboardButton textToCopy={props.redemptionId || ''}
                             title={getResource(resources, 'DAY_CORRECTION_REDEMPTION_TITLE')}
                             buttonTitle={getResource(resources, 'DAY_CORRECTION_REDEMPTION_BUTTON_TITLE')}/>
    </LabelGroup>

    <LabelGroup label={getResource(resources, 'DAY_CORRECTION_QUANTITY_LABEL')} rootCss={css`pointer-events: none;`}>
      <span>-1</span>
    </LabelGroup>

    <span>{getResource(resources, 'DAY_CORRECTION_INFO')}</span>

    <LabelGroup label={getResource(resources, 'DAY_CORRECTION_NOTE_LABEL')}>
      <Input title={getResource(resources, 'DAY_CORRECTION_INPUT')}
             maxLength={MAX_CORRECTION_NOTE_LENGTH}
             type='text'
             autoFocus={true}
             value={props.note}
             onChange={onNoteChange(props.onNoteChange)}
             placeholder={getResource(resources, 'DAY_CORRECTION_INPUT_PLACEHOLDER')}
             css={css`flex-grow: 1;`}/>
    </LabelGroup>

    <BigNeutral title={getResource(resources, 'DAY_CORRECTION_BUTTON_TITLE')}
                onClick={props.onSave}
                disabled={isNilOrEmpty(props.note)}
                style={{ alignSelf: 'flex-end' }}>
                  {getResource(resources, 'DAY_CORRECTION_BUTTON_TITLE')}
    </BigNeutral>
  </Column>
  )
};
